import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get("status");
  const projectId = params.get("project");
  const [countdown, setCountdown] = useState(6);

  useEffect(() => {
    const t = setInterval(() => setCountdown((c) => c - 1), 1000);
    const r = setTimeout(() => navigate(projectId ? `/project/${projectId}` : "/dashboard"), 6000);
    return () => { clearInterval(t); clearTimeout(r); };
  }, [navigate, projectId]);

  const config = {
    success: { icon: CheckCircle2, color: "text-emerald-400", title: "Ödeme Başarılı", desc: "%50 ön ödemeniz alındı. Projeniz üretime alınmak üzere sıraya girdi." },
    review: { icon: Clock, color: "text-amber-400", title: "Ödeme İncelemede", desc: "Ödemeniz güvenlik incelemesinde. Onaylandığında bilgilendirileceksiniz." },
    failed: { icon: XCircle, color: "text-red-400", title: "Ödeme Başarısız", desc: "Ödeme tamamlanamadı. Lütfen tekrar deneyin." },
  }[status] || { icon: XCircle, color: "text-red-400", title: "Bilinmeyen Durum", desc: "Ödeme durumu belirlenemedi." };

  const Icon = config.icon;

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6" data-testid="payment-return">
      <div className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-12 max-w-md text-center">
        <Icon className={`w-16 h-16 mx-auto mb-6 ${config.color}`} />
        <h1 className="font-serif text-4xl mb-3">{config.title}</h1>
        <p className="text-white/60 mb-8">{config.desc}</p>
        <Button onClick={() => navigate(projectId ? `/project/${projectId}` : "/dashboard")}
          data-testid="payment-continue-button"
          className="bg-gold text-black hover:bg-gold-light rounded-md h-11 px-8">
          Projeye Git ({countdown})
        </Button>
      </div>
    </div>
  );
}
